import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPlugin2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="plugin-2, build"><path d="M2.75 7.75H21.25V19.25H2.75V7.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M4.75 7.5V3.75H10.25V7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 7.5V3.75H19.25V7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPlugin2;
